import script from "./BidViewBidders.vue?vue&type=script&lang=ts&setup=true"
export * from "./BidViewBidders.vue?vue&type=script&lang=ts&setup=true"

import "./BidViewBidders.vue?vue&type=style&index=0&id=2d1ff8a5&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d1ff8a5"]])

export default __exports__